"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_social_content_service_1 = require("./base-social-content.service");
var API_REACTIONS = 'reactions';
var ReactionsService = /** @class */ (function (_super) {
    tslib_1.__extends(ReactionsService, _super);
    function ReactionsService(groupId, contextTokenRepository, apiClient) {
        if (apiClient === void 0) { apiClient = null; }
        return _super.call(this, groupId, contextTokenRepository, apiClient) || this;
    }
    ReactionsService.prototype.getItemUrl = function (itemId) {
        return API_REACTIONS + "/" + itemId;
    };
    ReactionsService.prototype.getReactions = function (params) {
        return this.apiClient.get(this.getItemUrl(params.itemId), {
            params: params,
        });
    };
    ReactionsService.prototype.react = function (body) {
        if (body === void 0) { body = {}; }
        return this.apiClient.post(this.getItemUrl(body.itemId) + "/react", body);
    };
    ReactionsService.prototype.unreact = function (body) {
        if (body === void 0) { body = {}; }
        return this.apiClient.post(this.getItemUrl(body.itemId) + "/unreact", body);
    };
    return ReactionsService;
}(base_social_content_service_1.BaseSocialContentService));
exports.ReactionsService = ReactionsService;
//# sourceMappingURL=reactions.service.js.map